import { Auth, base } from '@/utils';

type GetUsersCardsSetupParams = {
  userId: string;
};

type GetUsersCardsSetupResponse = {
  client_secret: string;
};

/**
 * SetupIntentのclient_secretを取得する
 * @param params
 * @returns
 */
export const getUsersCardsSetup = async ({
  userId,
}: GetUsersCardsSetupParams) => {
  const token = await Auth.getIdToken();

  const response = await base.post<GetUsersCardsSetupResponse>(
    `/v1/fruits/users/${userId}/cards/setup`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};
